<template>
  <a class="spoc-course-card" :href="authType == 2 && !userInfo ? '/login.html' : info.course_url" target="_blank">
    <div class="course-cover">
      <img :src="defaultCover[coverIndex]" alt="">
      <div class="cover-info">
        <div class="course-name text-overflow">{{ info.course_name }}</div>
        <div class="teacher-info">
          <span class="teacher-name text-overflow" title="">{{ info.lecturer }}</span>
          <span class="split" v-show="info.lecturer && info.organ_name"></span>
          <span title="" class="teacher-school text-overflow">{{ info.organ_name }}</span>
        </div>
      </div>
      <div class="left-line"></div>
    </div>
    <div class="course-info">
      <div class="count-choice"><span class="count">累计选课 <span class="unit">{{ info.students_num || 0 }}</span> 人</span></div>
      <div class="credit-hour">
        <span class="credit">学分 <span class="unit">{{ info.credit || 0 }}</span></span>
        <!-- <span class="split"></span> -->
        <span>学时 <span class="unit">{{ info.hours || 0 }}</span></span>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
		info: {
			type: Object,
			default () {
				return {
					course_name: "",
					course_url: "",
					credit: 0,
					course_cover_url: null,
					hours: "",
					id: "",
          lecturer: "",
					organ_name: "",
					students_num: 0,
				}
			}
		},
    userInfo: {
      type: Object,
      default: null
    },
    authType: Number
	},
  computed:{
		coverIndex(){
			let id = String(this.info.id)
			let length = id.length
			let lastId = id.charAt(length - 1)
			return (lastId % 4)
		}
	},
  data(){
		return{
			defaultCover:[
				require('@/assets/images/course_bg1.png'),
				require('@/assets/images/course_bg2.png'),
				require('@/assets/images/course_bg3.png'),
				require('@/assets/images/course_bg4.png')
			]
		}
	},
  methods: {
    getCourseUrl() {
      if (this.authType == 2 && !this.userInfo) {
        this.info.course_url = `/login.html`
      }
      console.log('this.info.course_url',this.info.course_url);
    },
    
  }
}
</script>

<style lang="scss" scoped>

.spoc-course-card {
  display: block;
  margin-top: 18px;
  margin-right: 21px;
  width: 157px;
  height: 154px;
  border: 1px solid #ddd;
  font-size: 14px;
  cursor: pointer;
  &:nth-child(4n) {
    margin-right: 0;
  }
  &:hover {
    border: 1px solid $--color-primary;
    box-shadow: 0 4px 4px 0px rgba($color: #000000, $alpha: 0.1);
  }
  .unit {
    color: $--color-primary;
  }
  .course-cover {
    position: relative;
    width: 282px;
    height: 108px;
    border-radius: 4px 4px 0 0;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .cover-info {
      position: absolute;
      top: 0;
      left: 0;
      width: 282px;
      height: 108px;
      padding: 19px 19px 0;
    }
    .course-name {
      width: 242px;
      height: 22px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #333;
      line-height: 22px;
    }
    .teacher-info {
      margin-top: 11px;
      margin-bottom: 4px;
      height: 15px;
      display: flex;
      align-items: center;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #999;
      .teacher-name {
        // min-width: 36px;
        max-width: 78px;
      }
      .split {
        display: inline-block;
        margin: 0 5px;
        margin-top: 1px;
        height: 12px;
        border-left: 1px solid #999;
      }
    }
    .left-line {
      position: absolute;
      top: 20px;
      left: 0;
      height: 18px;
      border-left: 1px solid $--color-primary;
    }
  }
  .course-info {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding:  0 20px;
    color: #999;
    line-height: 44px;
    font-size: 12px;
    .count-choice {
      flex: 1;  
          
    }
    .credit-hour {
      // flex: 1;
      // display: flex;
      // align-items: center;
      // .unit {
      //   margin-left: 2px;
      //   font-weight: 500;
      // }
      .credit {
        // margin-left: 26px;
        margin-right: 10px;
      }
    }
    
  }
}
</style>